import {
  buildTrackingSteps,
  BASE_STATUS_RANK,
  EVALUATION_STEP,
  OPERATION_STEP,
  CESSION_STEP,
  MONEY_TRANSFER_STEP,
  PAYMENT_STEP,
  riskReviewBullet,
  documentReviewBullet,
  ratificationReviewBullet,
} from '@fingo/lib/features/operations-status';

// ITAU: we don't know when document review / ratification happen in itau yet.
const STATUS_RANK = {
  ...BASE_STATUS_RANK,
  PENDINGDOCUMENTSREVIEW: 1,
  PENDINGRATIFICATION: 1,
  REJECTEDDOCUMENTS: 1,
  REJECTEDRATIFICATION: 1,
};

const ITAU_STEPS = [
  {
    ...EVALUATION_STEP,
    getBullets: (invoice, rank) => [
      riskReviewBullet(invoice, rank),
      documentReviewBullet(invoice, rank),
      ratificationReviewBullet(invoice, rank),
    ].filter(Boolean),
  },
  OPERATION_STEP,
  CESSION_STEP,
  MONEY_TRANSFER_STEP,
  PAYMENT_STEP,
];

const buildItauSteps = (invoice) => buildTrackingSteps(invoice, ITAU_STEPS, STATUS_RANK);

export default buildItauSteps;
